import React from 'react'
import Modal from 'react-modal'
import $ from 'jquery'

import { Editor } from '@tinymce/tinymce-react'

import CommError from '../../Shared/Errors/Errors'

import './CreateEditScope.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const ViewScope = (
    {
        curScope,
        isOpen,
        hdrToggle,
        onRequestCancel
    }) => (
    <div className="row">
        <div className="col-md-6 button-options-container">
            <div className="button-options">
                <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>
            </div>
        </div>

        <div className="row view">
            <div className="col-md-12">
                    <div className="scope-blk">
                    <p className="scope-blk-hdg">{curScope.name}<i className="fa fa-toggle-up pull-right" onClick={hdrToggle}></i></p>

                    <div className="row child-row instructions">
                        <div className="col-md-6 pull-right">
                            <label>Instructions</label>
                            <Editor initialValue={curScope.instructions}
                                init={
                                    {
                                        menubar: false,
                                        branding: false,
                                        elementpath: false,
                                        plugins: "autoresize",
                                        toolbar: false,
                                        content_css: "./CreateEditScope.css"
                                    }
                                }
                                apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row view">
            <div className="col-md-12">
                <div className="scope-blk">
                    <p className="scope-blk-hdg">PDF Output</p>

                    <div className="row child-row">
                        <div className="col-md-12">
                            <label>PARTIES</label>
                            <Editor initialValue={curScope.parties}
                                init={
                                    {
                                        menubar: false,
                                        branding: false,
                                        elementpath: false,
                                        plugins: "autoresize",
                                        toolbar: false,
                                        content_css: "./CreateEditScope.css"
                                    }
                                }
                                apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                            />
                        </div>
                    </div>

                    <div className="row child-row">
                        <div className="col-md-12">
                            <label>CONTRACTOR'S PROPOSAL</label>
                            <Editor initialValue={curScope.proposal}
                                init={
                                    {
                                        menubar: false,
                                        branding: false,
                                        elementpath: false,
                                        plugins: "autoresize",
                                        toolbar: false,
                                        content_css: "./CreateEditScope.css"
                                    }
                                }
                                apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="col-md-12 button-options-container">
            <div className="button-options">
                <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>
            </div>
        </div>
    </div>
);

const EditScope = (
    {
        curScope,
        tmpScope,

        create,
        isOpen,

        scopeNameChk,
 
        onInstructionsChange,
        onPartiesChange,
        onProposalChange,

        onAfterOpen,
        onRequestClose,
        onRequestCloseEdit,
        onRequestCancel
    }) => (
    <div className="row">
        <div className="col-md-6 button-options-container">
            <div className="button-options">
                <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>
                <button className="btn btn-primary sow" create={create ? "false" : "true"} onClick={onRequestClose}>Submit & Close</button>
                <button className="btn btn-primary sow" create={create ? "false" : "true"} onClick={onRequestCloseEdit}>Submit & Edit Tabs</button>
            </div>
        </div>

        <div className="col-md-12 optionsbody">
            <span>Active:</span> <input type="checkbox" id="active" defaultChecked={create ? curScope.active : tmpScope.active} />

            <p>Name:*</p>
            <input type="text" id="scopename" defaultValue={create ? curScope.name : tmpScope.name} onChange={scopeNameChk} />

            <p>Order:</p>
            <input type="text" id="order" defaultValue={create ? curScope.order : tmpScope.order} />

            <p>Form Instructions:</p>
            <Editor initialValue={create ? curScope.instructions : tmpScope.instructions}
                init={
                    {
                        menubar: false,
                        branding: false,
                        elementpath: false,
                        init_instance_callback: onInstructionsChange,
                        plugins: "lists advlist link image textcolor table hr code",
                        toolbar: "bold italic underline forecolor backcolor | styleselect numlist bullist | fontselect | fontsizeselect | link image | alignleft aligncenter alignright alignjustify | table hr code"
                    }
                }
                apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
            />

            <p>Parties:</p>
            <Editor initialValue={create ? curScope.parties : tmpScope.parties}
                init={
                    {
                        menubar: false,
                        branding: false,
                        elementpath: false,
                        init_instance_callback: onPartiesChange,
                        plugins: "lists advlist link image textcolor table hr code",
                        toolbar: "bold italic underline forecolor backcolor | styleselect numlist bullist | fontselect | fontsizeselect | link image | alignleft aligncenter alignright alignjustify | table hr code"
                    }
                }
                apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
            />

            <p>Contractor's Proposal:</p>
            <Editor initialValue={create ? curScope.proposal : tmpScope.proposal}
                init={
                    {
                        menubar: false,
                        branding: false,
                        elementpath: false,
                        init_instance_callback: onProposalChange,
                        plugins: "lists advlist link image textcolor table hr code",
                        toolbar: "bold italic underline forecolor backcolor | styleselect numlist bullist | fontselect | fontsizeselect | link image | alignleft aligncenter alignright alignjustify | table hr code"
                    }
                }
                apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
            />
        </div>

        <div className="col-md-12 button-options-container">
            <div className="button-options">
                <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>
                <button className="btn btn-primary sow" create={create ? "false" : "true"} onClick={onRequestClose}>Submit & Close</button>
                <button className="btn btn-primary sow" create={create ? "false" : "true"} onClick={onRequestCloseEdit}>Submit & Edit Tabs</button>
            </div>
        </div>
    </div>
);

const CreateEditScope = (
    {
        errScope,
        errScopeClear,

        curScope,
        tmpScope,

        create,
        isOpen,
        viewOnly,
        hdrToggle,

        scopeName,
        scopeNameChk,

        onInstructionsChange,
        onPartiesChange,
        onProposalChange,

        onAfterOpen,
        onRequestClose,
        onRequestCloseEdit,
        onRequestCancel
    }) => (
    <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
        <CommError error={errScope.error} onClose={errScopeClear} />

        <div className="create-edit-scope editpages productManagement">
            <div className="form-group">
                <div className="row">
                    <div className="col-md-12">
                        <div className="col-md-6 heading">
                            {
                                !create ?
                                    <h1>Create Scope of Work Project Type</h1>
                                : null
                            }
                            {
                                create && viewOnly ?
                                    <h1>View - {scopeName}</h1>
                                : null
                            }
                            {
                                create && !viewOnly ?
                                    <h1>Edit - {scopeName}</h1>
                                : null
                            }
                        </div>
                        {
                            viewOnly ?
                                <ViewScope
                                    curScope={curScope}
                                    isOpen={isOpen}
                                    hdrToggle={hdrToggle}
                                    onRequestCancel={onRequestCancel}
                                />
                            :
                                <EditScope
                                    curScope={curScope}
                                    tmpScope={tmpScope}

                                    create={create}
                                    isOpen={isOpen}

                                    scopeNameChk={scopeNameChk}

                                    onInstructionsChange={onInstructionsChange}
                                    onPartiesChange={onPartiesChange}
                                    onProposalChange={onProposalChange}

                                    onAfterOpen={onAfterOpen}
                                    onRequestClose={onRequestClose}
                                    onRequestCloseEdit={onRequestCloseEdit}
                                    onRequestCancel={onRequestCancel}
                                />
                        }
                    </div>
                </div>
            </div>
        </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default CreateEditScope